import Tooltip from "@mui/material/Tooltip";
import { Folder } from "@mui/icons-material";
import { Stack, useTheme } from "@mui/system";
import Typography from "@mui/material/Typography";
import useTranslations from "../hooks/useLanguageHook";

type MultipleViewTitleGridProps = {
  fileName: string;
  providerName: string;
  handleHide?: () => void;
};

function MultipleViewTitleGrid({ fileName, providerName, handleHide }: MultipleViewTitleGridProps) {
  const theme = useTheme();
  const { t } = useTranslations();

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Tooltip title={t.Vis.ClickToHideExport} placement="bottom" arrow>
        <Folder
          sx={{
            color: theme.palette.primary.light,
            cursor: "pointer",
            "&:hover": {
              color: theme.palette.grey[600],
            },
          }}
          onClick={handleHide}
        />
      </Tooltip>
      <Typography variant={"body1"}>
        {fileName} {t.Vis.from} {providerName}
      </Typography>
    </Stack>
  );
}

export default MultipleViewTitleGrid;
